var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Section',[_c('H',[_vm._v("404")]),_c('H',{attrs:{"level":2}},[_vm._v("Not found")]),_c('P',[_vm._v("The page you are looking for does not exist.")]),_c('router-link',{class:_vm.$style.cta,attrs:{"to":"/"}},[_vm._v("Go home")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }